import React, { useEffect, useState } from "react";
import { Form, Checkbox, Input, Button, Icon, Text, Bubble, H3, Tabs, TabPanel, Badge, Justify } from "@tencent/tea-component";
import { checkSupport, IS_MOBILE, IS_IOS } from '../util/browser';
import { t, Trans } from '@tencent/tea-app/lib/i18n';
import { getUrlParameter } from '../util';
import { playSources as sources } from '../router/tcplayer';
import { Button as TButton } from 'tdesign-react'
import 'tdesign-react/es/style/index.css'; // 少量公共样式
function PlayPanel (props) {
  const [type, setType] = useState(getUrlParameter('playmode') || props.type || 'playurl');
  const queryUrl = (getUrlParameter('url') + (getUrlParameter('txTime') ? `&txTime=${getUrlParameter('txTime')}`  : '' ));
  const [url, setUrl] = useState<string>(queryUrl || sources[window['LANGUAGE']].url);
  const [webrtcSupport, setWebrtcSupport] = useState<boolean>();
  const [h264Support, setH264Support] = useState<boolean>();


  const [fileID, setFileID] = useState<string>(getUrlParameter('fileid') || sources[window['LANGUAGE']].fileID);
  const [appID, setAppID] = useState<string>(getUrlParameter('appid') || sources[window['LANGUAGE']].appID);
  const [psign, setPsign] = useState<string>(getUrlParameter('psign') || sources[window['LANGUAGE']].psign);

  useEffect(() => {
    const support = async () => {
      const support = await checkSupport();
      setWebrtcSupport(!!support.support);
      setH264Support(!!support.h264Support);
    }

    support();
  }, []);

  useEffect(() => {
    preview();
  }, [type]);

  const preview = () => {
    if (type === 'playfileid') {
      if (!fileID || !appID) return false;
    } else {
      if (!url) return false;
    }
    props.onPreview && props.onPreview({
      url,
      type,
      fileID,
      appID,
      psign,
    });    
  }

  const reset = () => {
    if (type === 'playfileid') {
      setFileID('');
      setAppID('');
      setPsign('');
    } else {
      setUrl('');
    }
  }

  return <div style={{ padding: '0 20px' }}>
  {
    type === 'playfileid' ? <>
      <Text reset>fileID:</Text>
      <Input
        size='full'
        style={{ margin: '5px 0 10px 0' }}
        value={fileID}
        onChange={(value, context) => {
          setFileID(value);
        }}
        placeholder={t("输入fileID")}
      />
      <br />
      <Text reset>appID:</Text>
      <Input
        size='full'
        style={{ margin: '5px 0 10px 0' }}
        value={appID}
        onChange={(value, context) => {
          setAppID(value);
        }}
        placeholder={t("输入appID")}
      />
      <br />
      <Text reset>psign:</Text>
      <Input
        size='full'
        style={{ margin: '5px 0 10px 0' }}
        value={psign}
        onChange={(value, context) => {
          setPsign(value);
        }}
        placeholder={t("输入psign")}
      />
      <Button type="link" style={{ margin: '10px 10px 0 0' }}><a target="_blank" rel="noreferrer" href={"https://cloud.tencent.com/document/product/266/46217#.E6.AD.A5.E9.AA.A42.EF.BC.9A.E7.94.9F.E6.88.90.E6.92.AD.E6.94.BE.E5.99.A8.E7.AD.BE.E5.90.8D"}>{t('如何获取腾讯云点播的fileID、appID、psign')}</a></Button>
    </> : <>
      <Justify left={
        <H3 style={{ minWidth: 60 }}>{t('播放地址')}</H3>
      } right={
        <div className="webrtc-support">
          <Bubble
            arrowPointAtCenter
            placement="top-end"
            content={webrtcSupport ? t('当前浏览器支持 WebRTC 协议') : t('当前浏览器不支持 WebRTC 协议')}
          >
            <Badge theme={webrtcSupport ? 'success' : 'warning'}>WebRTC { webrtcSupport ? '' : 'Not' } Support</Badge>
          </Bubble>
          <Bubble
            arrowPointAtCenter
            placement="top-end"
            content={h264Support ? t('当前浏览器支持 H264 编码') : t('当前浏览器不支持 H264 编码')}
          >
            <Badge theme={h264Support ? 'success' : 'warning'}>H264 { h264Support ? '' : 'Not' } Support</Badge>
          </Bubble>
        </div>
      } />
      
      <Input
        style={{ margin: '5px 0 10px 0' }}
        size='full'
        value={url}
        onChange={(value, context) => {
          setUrl(value);
        }}
        placeholder={t("输入视频地址")}
      />
      <div>
        <Text theme="label" reset>{t('支持WebRTC、FLV、HLS的直播流地址，以及HLS、FLV、MP4等格式的点播播放地址')}</Text>
      </div>
      <>
        <Button type="link" style={{ margin: '10px 10px 0 0' }}><a target="_blank" rel="noreferrer" href={(window as any).lang === "en" ? "https://www.tencentcloud.com/document/product/267/38393" : "https://cloud.tencent.com/document/product/267/32720"}>{t('如何获取云直播的直播流地址')}</a></Button>
        <Button type="link" style={{ margin: '10px 10px 0 0' }}><a target="_blank" rel="noreferrer" href={(window as any).lang === "en" ? "https://www.tencentcloud.com/document/product/266/33895" : "https://cloud.tencent.com/document/product/266/36451"}>{t('如何获取云点播的视频地址')}</a></Button>
      </>
      
    </>
  }

    <section style={{ position: 'absolute', bottom: '20px' }}>
      <TButton shape="round" onClick={preview} style={{ fontWeight: 'normal', marginRight: '12px', height:'30px', fontSize:'12px', padding:'5px 20px'}}>
        {t('预览')}
      </TButton>
      <TButton shape="round" variant='outline' theme='primary' onClick={reset} style={{ fontWeight: 'normal', height:'30px', fontSize:'12px', padding:'5px 20px'}}>
        {t('重置')}
      </TButton>
    </section>
  </div>
}

export default PlayPanel;